import { TextCell } from '@ayocore/platform/client/components/EditableGrid';
import type { EditableGridColumn } from '@ayocore/platform/client/components/EditableGrid';
import type { WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey } from './types';

export const workOrderNotesColumn: EditableGridColumn<
  WorkOrderRow,
  WorkOrderPatch,
  WorkOrderColumnKey
> = TextCell<WorkOrderRow, WorkOrderPatch, WorkOrderColumnKey>({
  key: 'notes',
  title: 'Примечания',
  width: 140,
  placeholder: 'Комментарий...',
  multiline: 'auto',
});
